<template>

    <template v-if="$route.params.qPage === 'Criar' || $route.params.qPage === 'Editar'">
        <v-card>
            <v-card-text class="mb-6">
                <v-alert v-model="alert" class="my-3" closable :text="alertText" :type="alertType" />
                <v-form v-model="isFormValid" @submit.prevent="onSubmit">
                    <v-text-field v-model="nome.value.value" color="primary" label="Nome" :counter="60" :error-messages="nome.errorMessage.value" />
                    <v-select v-model="qtdAlt" color="primary" label="Quantidade de alternativas por questão" :items="items" />
                    <v-card v-for="(question, i) in questions" :key="i" class="mb-4" variant="outlined">
                        <v-card-item class="bg-primary-litghen-1">
                            <v-card-title :id="'question-' + (i + 1)">Questão {{ (i + 1) }}:</v-card-title>
                            <v-sheet>
                                <VeeQuill :name="`Questions[${i}].question`" />
                            </v-sheet>
                        </v-card-item>
                        <v-card-item class="bg-primary-litghen-1 pt-0">
                            <VeeSelect
                                :name="`Questions[${i}].difficulty`"
                                :items="difficultyItems"
                                label="Nível de dificuldade"
                            />
                        </v-card-item>
                        <v-divider />
                        <v-card-item min-height="50" class="bg-tertiary-litghen-1">
                            <v-card-title>Resposta correta:</v-card-title>
                            <v-sheet>
                                <VeeRadio :name="`Questions[${i}].altTrue`" :number=computedQtdAlt.length />
                            </v-sheet>
                        </v-card-item>
                        <v-card-item v-for="(answer, j) in computedQtdAlt" :key="j" class="bg-tertiary-litghen-1">
                            <div class="mt-1 mr-2"><v-card-title>Alternativa {{ altsName[j] }}:</v-card-title></div>
                            <v-sheet>
                                <VeeQuill :name="`Questions[${i}].answers[${j}].answer`" />
                            </v-sheet>
                        </v-card-item>
                        <v-divider />
                        <v-card-actions v-if="i != 0">
                            <v-btn prepend-icon="mdi-minus-circle" elevation="4" variant="flat" @click="remove(i)">
                                <template v-slot:prepend>
                                    <v-icon color="error" />
                                </template>
                                Deletar questão
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                    <div class="mb-4">
                        <v-btn prepend-icon="mdi-plus-circle" @click="addQuestion()">
                            <template v-slot:prepend>
                                <v-icon color="success" />
                            </template>
                            Adicionar questão
                        </v-btn>
                    </div>
                    <div v-if="!isFormValid" class="text-danger">Preencha todos os campos obrigatórios.</div>
                    <v-btn class="bg-primary me-4" type="submit" :disabled="!isFormValid" :loading="loadingQ">{{ btnName }}</v-btn>
                    <v-btn class="bg-primary" @click="handleReset()">Limpar</v-btn>
                </v-form>
            </v-card-text>
        </v-card>
        <v-sheet class="mx-auto max-width-sheet">
            <v-slide-group show-arrows>
                <v-slide-group-item v-for="(question, i) in questions" :key="i" v-slot="{ isSelected, toggle }">
                <v-btn
                    class="ma-2"
                    :color="isSelected ? 'primary' : undefined"
                    :href="'#question-' + (i + 1)"
                    @click="toggle"
                >
                    Questão {{ (i + 1) }}
                </v-btn>
                </v-slide-group-item>
            </v-slide-group>
        </v-sheet>
    </template>

    <template v-else>
        <v-container fluid>
            <v-data-table v-model:sort-by="sortBy" class="elevation-2 table" hover 
            items-per-page-text="Itens por página" page-text="{0}-{1} de {2}"  
            :headers="headers" :items="listQuestions" :loading="loading">
                <template v-slot:no-data>
                    <v-alert class="my-4" :value="true">
                        <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                    </v-alert>
                </template>
                <template v-slot:item.datetime="{ item }">{{ formatDate(item.columns.datetime) }}</template>
                <template v-slot:item.id="{ item }">
                    <v-icon icon="mdi-pencil" class="ma-2 pa-2" color="primary" size="small" @click="editQuestion(item.columns.id)" />
                    <v-icon icon="mdi-delete" class="ma-2 pa-2" color="error" size="small" @click="deleteQuestionAsk(item.columns.id)" />
                </template>
            </v-data-table>
        </v-container>

        <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
                <v-toolbar class="bg-primary-darken-1" elevation="1">
                    <v-spacer />
                    <v-icon color="warning" icon="mdi-alert" size="x-large" />
                    <v-spacer />
                </v-toolbar>
                <v-card-title class="text-center">Você tem certeza que deseja deletar este<br /> questionário?</v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red" variant="flat" @click="deleteQuestionConfirm(idQuestion)">Sim</v-btn>
                    <v-btn class="bg-primary" variant="flat" @click="closeDelete">Cancelar</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </template>

    <v-snackbar v-model="snackbar" :color="sbColor">
        {{ sbMessage }}
        <template v-slot:actions>
            <v-btn @click="snackbar = false">
                Fechar
            </v-btn>
        </template>
    </v-snackbar>
</template>

<style type="text/css">
.v-data-table.table .v-table__wrapper>table>thead>tr th,
.v-data-table.table .v-table__wrapper>table tbody>tr th {
    background-color: #16324A !important;
    color: white;
}
.v-data-table .v-table__wrapper>table>thead>tr>th.v-data-table__th--sortable:hover,
.v-data-table .v-table__wrapper>table tbody>tr>th.v-data-table__th--sortable:hover {
    color: white;
}
.ql-editor  {min-height: 100px;}
.ql-tooltip {
    top: -10px !important;
    left: 0!important;
}
.max-width-sheet {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  /*max-width: 240px;*/
  max-width: 600px;
  width: 100%;
  background-color: rgba(255, 255, 255, 0); /* Fundo transparente (aqui, 0.7 é a transparência) */
  z-index: 1000; /* Z-index para sobrepor outros elementos, se necessário */
}
</style>

<script src="@/assets/js/questionario.js" />
